<p>tender-receipt-tape-preview works!</p>
